// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {FetchReservationOfferSuccess} from 'redux/v1/reservation/offer/actions';
import type {
  OfferState,
  ReservationOffer,
} from 'redux/v1/reservation/offer/OfferState';
import type {SelectReservationSuccess} from 'redux/v1/reservation/select/actions';

import {
  createReducerUsingActionHandlers,
  ERROR,
  PENDING,
  SUCCESS,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {FETCH_RESERVATION_OFFER} from 'redux/v1/reservation/offer/actions';
import {offerState} from 'redux/v1/reservation/ReservationState';
import {
  SELECT_RESERVATION,
  UNSELECT_RESERVATION,
} from 'redux/v1/reservation/select/actions';

export const initialState: OfferState = {
  loading: false,
};

const actionCreators: ActionHandlers<OfferState> = {
  [PENDING(FETCH_RESERVATION_OFFER)]: (state: OfferState) => ({
    ...state,
    loading: true,
  }),
  [SUCCESS(FETCH_RESERVATION_OFFER)]: (
    state: OfferState,
    action: FetchReservationOfferSuccess
  ) => ({
    ...state,
    loading: false,
    data: action.data[0] || null,
  }),
  [ERROR(FETCH_RESERVATION_OFFER)]: (state: OfferState, action: any) => ({
    ...state,
    loading: false,
    error: action.error.toJSON().message,
  }),
  [SUCCESS(SELECT_RESERVATION)]: (
    state: OfferState,
  ) => ({
    ...state,
    data: {
      ...state.data,
      selected: true,
    },
  }),
  [SUCCESS(UNSELECT_RESERVATION)]: (
    state: OfferState,
  ) => ({
    ...state,
    data: {
      ...state.data,
      selected: false,
    },
  }),
};

export const offerReducer: Reducer<OfferState> = // $FlowIgnore
  createReducerUsingActionHandlers<OfferState>(initialState, actionCreators);

export const offerLoaded: Selector<boolean> = createSelector(
  offerState,
  (state: OfferState) => !state.loading && state.data !== undefined
);

export const getOffer: Selector<ReservationOffer> = createSelector(
  [offerState, offerLoaded],
  (state: OfferState, loaded: boolean) => loaded && state.data
);

export const getReservationType: Selector<string> = createSelector(
  [offerState, offerLoaded],
  (state: OfferState, loaded: boolean) => loaded && state.data?.reservationType
);
